import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { ChapterEnrollment } from "./chapterEnrollment";
import { DocumentReference } from "@angular/fire/compat/firestore";
import { Language } from "../utils/language";
import { Timestamp } from "firebase/firestore";

export class CourseEnrollment extends FBase {

	name: string = null;
	image: string = null;
	description: string = null;
	languages: Language[] = [];
	duration: number = 0;
	completedAt: Timestamp = null;
	chapterEnrollments: ChapterEnrollment[] = [];
	completedPercentage: number = 0;
	totalChapters: number = 0;
	guidedMode: boolean = false;
	requirePassToContinue: boolean = true;
	languageCourseReference: DocumentReference = null;
	isFavorite: boolean = false;
	lastChapterSeen: number = null;

	index: number = 0;
	__categoryId: string = null;
	// Set when the enrollment comes from the My Courses summary, which carries the count instead
	// of the chapter enrollments themselves. Null means "count chapterEnrollments".
	__completedChapters: number = null;

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}
}
export namespace CourseEnrollment {

	export const PATH = 'courseEnrollments';

}
